import VectorLayer from 'ol/layer/Vector';
import OlCore from '../OlCore';
import VectorSource from 'ol/source/Vector';
import VectorModule from '../Module/VectorModule';
import { Circle, Fill, Icon, Stroke, Style, Text } from 'ol/style';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import IcoAlertMarker from 'assets/images/2dMap/ico-alert-marker.png';
import { baseProjection, targetProjection } from '../../projection';

class ObjectAlertPoint extends VectorModule {
  private alertPointLayer: VectorLayer<VectorSource>;
  private clickListener?: (evt: any) => void;
  constructor(core: OlCore) {
    super(core);

    this.alertPointLayer = new VectorLayer({
      properties: {
        id: 'AlertPoint',
      },
      visible: true,
      zIndex: 4,
      style: () => {
        return [
          new Style({
            image: new Icon({
              src: IcoAlertMarker,
              anchor: [0.5, 1],
              scale: 1,
            }),
          }),
        ];
      },
    });
    this.setLayers([this.alertPointLayer]);
  }

  public draw(datas) {
    // 피쳐배열
    const features: Feature[] = [];

    // 데이터 반복
    datas.map((i) => {
      features.push(
        new Feature({
          geometry: new Point([i.y, i.x]).transform(targetProjection, baseProjection),
          properties: {},
        }),
      );
    });
    const source = this.createSource(features);
    this.alertPointLayer.setSource(source); // 벡터 소스 초기화 및 새로운 소스 추가됨

    //  mapInstance
    //          ?.getMapInstance()
    //          .getView()
    //          .animate({
    //            center: [selected.position.y, selected.position.x],
    //            zoom: 20, // 22
    //            duration: 100,
    //          });
  }

  public remove() {
    this.alertPointLayer.setSource(null);
  }

  // ⭐ 지도에 클릭 이벤트 연결
  public activateClickEvent(callback?: any) {
    if (this.clickListener) {
      return;
    }
    console.log('새로 등록');

    this.core.getMapInstance();
    const map = this.core.getMapInstance(); // core에서 map instance 받아온다고 가정
    if (!map) return;

    this.clickListener = (evt) => {
      const pixel = evt.pixel;

      // 클릭한 곳에 feature가 있는지 체크
      const feature = map.forEachFeatureAtPixel(pixel, (feat) => feat);

      if (!feature) {
        console.log('Feature 없음, 소스 초기화');
        this.alertPointLayer?.setSource(null);
        callback && callback();
      }
    };

    map.on('singleclick', this.clickListener);
  }

  // ⭐ 지도 클릭 이벤트 제거
  public deactivateClickEvent() {
    const map = this.core.getMapInstance();
    if (!map || !this.clickListener) return;

    map.un('singleclick', this.clickListener);
    this.clickListener = undefined;
  }
}
export default ObjectAlertPoint;
